module.exports = new __parcel__URL__("pin_oudormir.d723dc5a.png").toString();